module.exports = __webpack_public_path__ + "static/banya-511aaacdf5195a49e6bb06738c41148b.jpg";